import {getBlackoutPeriod} from "../../api/getBlackoutPeriods";

export const DataSourceDependencies = {
    dashboardRoutes: ['/', '/dashboard'],
    flowsRoutes: ['/automation', '/automations', '/flow', '/flows', '/templates', '/dashboard', '/', '/reports', '/logs', '/messages'],
    templatesRoutes: ['/templates', '/dashboard', '/', '/reports', '/logs', '/messages'],
    campaignsRoutes: ['/templates', '/dashboard', '/', '/reports', '/logs', '/messages', '/campaigns', '/audience', '/campaigns-insights'],
    messagesRoutes: ['/messages'],
    checkoutsRoutes: ['/checkouts'],
    ordersRoutes: ['/orders'],
    wabaRoutes: ['/', '/dashboard', '/templates', '/settings', '/mobile-settings', '/messages', '/automations', '/automation', '/flows', '/flow', 'orders', '/checkouts', '/reports', '/logs', '/campaigns', '/audience'],
    blackoutPeriodRoutes: ['/settings', '/mobile-settings', '/dashboard', '/', '/templates', '/messages', '/checkouts', '/reports', '/logs', '/orders'],
    shopRoutes: ['/settings', '/mobile-settings', '/dashboard', '/', '/templates', '/messages', '/checkouts', '/reports', '/logs', '/orders'],
    conversations: ['/', '/conversations', '/templates', '/messages', '/automations', '/dashboard', '/reports', '/logs', '/checkouts', '/settings', '/mobile-settings', '/orders'],
    segments: ['/conversations', '/templates', '/campaigns', '/audience'],
    // shopClients: [],
}